
const productRoutes = [
  {
    path: '/product/collect',
    name: 'productCollect',
    component: () => import(/* webpackChunkName: "productCollect" */ '/@/views/product/collect/index.vue'),
    meta: {
      title: "收藏产品",
      keepAlive: true,
    },
  },
  {
    path: '/product/download',
    name: 'productDownload',
    component: () => import(/* webpackChunkName: "productDownload" */ '@/views/product/download/index.vue'),
    meta: {
      title: "下载",
      keepAlive: true,
    },
  },
  {
    path: '/product/detail/:id',
    name: 'productDetail',
    component: () => import(/* webpackChunkName: "productDetail" */ '@/views/product/detail/index.vue'),
    meta: {
      title: "产品详情",
    },
  },
  {
    path: '/product/list/:compid',
    name: 'productList',
    component: () => import(/* webpackChunkName: "productList" */ '@/views/product/productList/index.vue'),
    meta: {
      title: "零部件",
    },
  },
];

export default productRoutes;
